import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { SafeUrlPipePipe } from './pipes/safe-url-pipe.pipe';
import { ScrollAnimateDirective } from '../directive/scroll-animate.directive'; // ScrollAnimateDirective is declared here
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SafeUrlPipePipe,
    ScrollAnimateDirective 
  ],
  imports: [
    CommonModule,
  ],
  exports: [  
    HeaderComponent,
    FooterComponent,
    SafeUrlPipePipe,
    ScrollAnimateDirective 
  ]
})
export class SharedModule { }
